var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSuccessIcon = function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154 80c0 40.869-33.131 74-74 74-40.87 0-74-33.131-74-74C6 39.13 39.13 6 80 6c40.869 0 74 33.13 74 74Z",
    fill: "#F7F9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m135 46-30-32v28a4 4 0 0 0 4 4h26Z",
    fill: "#E4E9ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 141a4 4 0 0 0 4 4h94a4 4 0 0 0 4-4V46h-26a4 4 0 0 1-4-4V14H37a4 4 0 0 0-4 4v123Z",
    fill: "#FBFCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135 46h.5v-.198l-.135-.144L135 46Zm-30-32 .365-.342-.148-.158H105v.5Zm26 130.5H37v1h94v-1ZM33.5 141V18h-1v123h1Zm101-95v95h1V46h-1Zm.865-.342-30-32-.73.684 30 32 .73-.684ZM109 46.5h26v-1h-26v1ZM104.5 14v28h1V14h-1Zm-67.5.5h68v-1H37v1Zm0 130a3.5 3.5 0 0 1-3.5-3.5h-1a4.5 4.5 0 0 0 4.5 4.5v-1Zm94 1a4.5 4.5 0 0 0 4.5-4.5h-1a3.5 3.5 0 0 1-3.5 3.5v1Zm-22-100a3.5 3.5 0 0 1-3.5-3.5h-1a4.5 4.5 0 0 0 4.5 4.5v-1ZM33.5 18a3.5 3.5 0 0 1 3.5-3.5v-1a4.5 4.5 0 0 0-4.5 4.5h1Z",
    fill: "#E4E9ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.66 101.625a1.75 1.75 0 1 1 2.68-2.25l-2.68 2.25Zm39-2.25a1.75 1.75 0 1 1 2.68 2.25l-2.68-2.25ZM64 100.5a223.7 223.7 0 0 0 1.34-1.126h-.001l-.001-.002a25.447 25.447 0 0 0 4.716 3.903c3.126 1.995 7.678 3.975 13.446 3.975v3.5c-6.598 0-11.796-2.27-15.329-4.525a28.952 28.952 0 0 1-4.051-3.112 21.995 21.995 0 0 1-1.062-1.047 14.443 14.443 0 0 1-.362-.398l-.024-.028a.078.078 0 0 1-.007-.009l-.003-.003-.001-.002s-.001-.001 1.339-1.126Zm19.5 6.75c5.768 0 10.32-1.98 13.446-3.975a25.431 25.431 0 0 0 3.558-2.732 18.494 18.494 0 0 0 1.104-1.11l.046-.052.008-.009-.001.001h-.001c0 .001 0 .002 1.34 1.127s1.34 1.126 1.339 1.126l-.001.002-.003.003-.007.009-.024.028a14.346 14.346 0 0 1-.362.398c-.244.259-.599.619-1.062 1.047a28.946 28.946 0 0 1-4.051 3.112c-3.533 2.255-8.731 4.525-15.329 4.525v-3.5ZM63.195 71.446a1.75 1.75 0 0 0 1.61 3.108l-1.61-3.108Zm10 3.108a1.75 1.75 0 0 0 1.61-3.108l-1.61 3.108ZM64 73l.804 1.554s-.001 0 0 0h.002l.017-.01a10.627 10.627 0 0 1 .396-.19c.277-.128.667-.298 1.114-.468.947-.36 1.95-.636 2.667-.636v-3.5c-1.385 0-2.883.474-3.91.864a21.086 21.086 0 0 0-1.889.829l-.003.002h-.002L64 73Zm5 .25c.718 0 1.72.276 2.667.636a17.655 17.655 0 0 1 1.527.668h.003-.001L74 73l.804-1.554-.002-.001-.003-.002a21.086 21.086 0 0 0-1.889-.829c-1.027-.39-2.525-.864-3.91-.864v3.5ZM92.006 71.56a1.75 1.75 0 1 0 1.988 2.88l-1.988-2.88Zm10 2.88a1.75 1.75 0 1 0 1.988-2.88l-1.988 2.88ZM93 73l.994 1.44-.001.001.002-.001.016-.011.078-.052a15.39 15.39 0 0 1 1.413-.816c.955-.484 1.888-.811 2.498-.811v-3.5c-1.493 0-3.06.673-4.08 1.189a18.914 18.914 0 0 0-1.865 1.087l-.033.023-.01.007-.004.002-.001.001L93 73Zm5-.25c.61 0 1.543.327 2.498.811a15.508 15.508 0 0 1 1.491.868l.016.01.003.002h-.002L103 73l.994-1.44h-.001l-.001-.002-.004-.002-.01-.007a18.64 18.64 0 0 0-1.899-1.11c-1.018-.516-2.586-1.189-4.079-1.189v3.5Z",
    fill: "#B0E9E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 42.5h17M47.5 32H70",
    stroke: "#E4E9ED",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 25,
    r: 6,
    fill: "#F5FAFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 4,
    r: 4,
    fill: "#F5FAFA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 27,
    r: 4,
    fill: "#F5FAFA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 133,
    r: 8,
    fill: "#F5FAFA"
  })));
};

export { SvgSuccessIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/success-icon.8ed59ee6.svg";